var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16659 17.3332C0.945572 17.3332 0.73361 17.2454 0.57733 17.0891C0.421049 16.9328 0.333252 16.7208 0.333252 16.4998V1.49984C0.333252 1.27882 0.421049 1.06686 0.57733 0.910582C0.73361 0.754301 0.945572 0.666504 1.16659 0.666504H12.8333C13.0543 0.666504 13.2662 0.754301 13.4225 0.910582C13.5788 1.06686 13.6666 1.27882 13.6666 1.49984V3.99984H11.9999V2.33317H1.99992V15.6665H11.9999V13.9998H13.6666V16.4998C13.6666 16.7208 13.5788 16.9328 13.4225 17.0891C13.2662 17.2454 13.0543 17.3332 12.8333 17.3332H1.16659ZM11.9999 12.3332V9.83317H6.16658V8.1665H11.9999V5.6665L16.1666 8.99984L11.9999 12.3332Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.af9c64185f4d3d1e2dd378590b1ec612.svg";
export { ForwardRef as ReactComponent };